import styled from 'styled-components';

export const Container = styled.div`
  height: auto;
  padding: 30px 120px;
  background-color: rgba(255, 255, 255, 255);
`
export const Box = styled.div`
  display: inline-block;
  vertical-align: center;
  /* width: 0%; */
  padding: 0 80px;
  font-family: 'Rubik', sans-serif;
  background-color: rgba(255, 255, 255, 255); 
  height: auto;
  line-height: 20px;
`

export const IntroPar = styled.p`
  padding-top: 20px;
  font-family: 'Rubik', sans-serif;
  color: #000;
  font-size: 1.3em;
  font-weight: 400;
  line-height: 1.5em;
  /* width: 80%; */

`


export const PubLink = styled.a`
  margin-top: 0;
  float: none;
  color: #92CC26;
`
